

import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


import Shelf from './shelf'

import lazySizes from 'lazysizes';

import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      config.set('log', false); // disables unnecessary console.log calls

      
      const components = {

        Shelf: Shelf
      }

      loadComponents(components)

      this.form = document.getElementById('form')
      this.button = document.getElementById('submit')
      this.thanks = document.getElementById('thanks')

      this.form.addEventListener("submit", (ev) => {
        ev.preventDefault();

        const formData = new FormData(this.form);

        fetch("/", {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded"
            },
            body: new URLSearchParams(formData).toString(),
          })
          .then((e) => this.success(e))
          .catch((error) => this.error(error));


      });
  }



  success(e) {

    if (e.ok) {

      this.form.remove();
      this.thanks.append('Mesajul a fost trimis. Revenim curând cu un răspuns!')


    } else {
      this.error()
    }

  }

  error() {
    this.form.remove();
    this.thanks.append('A interenit o eroare. Vă rugăm să încercați mai tărziu!')
  }


}

module.exports = App
